import { createSelector } from 'reselect';
export const getSort = state => state.sorts;
export const getRepOverviewTableSort = createSelector([getSort], sort => sort.repOverviewTableSort);